module.exports = __webpack_public_path__ + "img/location.7e70b6ee.svg";